package com.essntl.core.quickbooks.data

import kotlinx.serialization.Serializable

@Serializable
data class QuickbooksCategoryQueryDto(
    val QueryResponse: QuickbooksCategoryQueryResponse,
)

@Serializable
data class QuickbooksCategoryQueryResponse(
    val Item: List<QuickbooksCategory>,
)